import { AbstractControl } from '@angular/forms';

// według algorytmu -> http://geo-oko.blogspot.com/2013/08/jak-obliczyc-cyfre-kontrolna-w-numerze.html

export function ValidateLandMortgageRegister(control: AbstractControl) {
    let number = control.value;
    if (number === null || number === undefined || number.length === 0) {
        // if pesel is not present, dont send error, use Validators.required
        return null;
    }
    const keys = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        X: 10,
        A: 11,
        B: 12,
        C: 13,
        D: 14,
        E: 15,
        F: 16,
        G: 17,
        H: 18,
        I: 19,
        J: 20,
        K: 21,
        L: 22,
        M: 23,
        N: 24,
        O: 25,
        P: 26,
        R: 27,
        S: 28,
        T: 29,
        U: 30,
        W: 31,
        Y: 32,
        Z: 33
    }
    const split = number.split('/');
    if (split.length === 3) {
        number = split[0] + split[1];
        const check = Number(split[2]);
        if (number.length === 12) { // sprawdzamy czy ciąg ma 12 cyfr
            const steps = new Array(1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7); // tablica z odpowiednimi wagami
            let intSum = 0;
            for (let i = 0; i < 12; i++) {
                intSum += steps[i] * keys[number[i]]; // mnożymy odpowiednik każdego ze znaków przez wage i sumujemy wszystko
            }
            let intControlNr = (intSum % 10); // obliczamy sumę kontrolną
            if (intControlNr === check) { // sprawdzamy czy taka sama suma kontrolna jest w ciągu
                // tslint:enable
                return null;
            }
        }
    }
    return { validLandMortgageRegister: true };
}
